import { toWorkflowData } from '@data/schemas/workflowData'
import { get } from 'lodash-es'

export const toInterestsData = (data: unknown): InterestsWorkflowData => {
    return {
        interestCategories: get(data, 'interestCategories'),
        userInterests: get(data, 'userInterests'),
        workflow: toWorkflowData(data),
        workflowType: 'interests',
        user: get(data, '_embedded.user'),
    }
}
